<template>
  <div class="border-component" :style="computedStyle">
    <img @click.stop.prevent :src="options.imgSrc" alt="" :style="imgStyle"/>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
export default {
  mixins: [eventMixin],
  name: "cxBorder",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {
    imgSrc() {
      return require("assets/images/leftMenu/border/" + this.options.imgSrc)
    },
    computedStyle() {
      return {
        width: this.options.width + "px",
        height: this.options.height + "px",
        transform: "rotate(" + this.options.rotate + "deg)"
      }
    },
    imgStyle() {
      return {
        userSelect: this.isBigScreenPreview() ? 'none' : 'auto'
      }
    }
  },
  methods: {
    async updateData() {}
  }
}
</script>

<style scoped>
.border-component {
  padding: 16px;
  box-sizing: border-box;
  pointer-events: none;
}
.border-component img {
  width: 100%;
  height: 100%;
}
</style>
